import { InjectionToken } from '@angular/core';
import { SagaObject_abstract } from '@models/imported/abstract/SagaBase/SagaObject_abstract';

export const CALLCARD_TYPE_INJECTION_TOKEN = new InjectionToken<SagaObject_abstract>('CallCardType');
